<template>
  <div class="flex flex-col items-center space-y-3 flex-grow justify-start">
    <span v-if="title" class="font-bold">
      {{ title }}
    </span>
    <span
      :class="[!size ? 'text-3xl' : `${size} `]"
      class="text-carpo font-semibold"
    >
      {{
        total != null
          ? total.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
          : ''
      }}
    </span>
    <h2 v-if="showType != false" class="text-gray-500 text-xs">
      <span v-if="customType">
        {{ customType }}
      </span>
      <span v-else>km {{ type ? `/${type}` : '' }}</span>
    </h2>
  </div>
</template>

<script>
import { currency } from '@/mixins/currency'
export default {
  props: ['summary', 'type', 'title', 'showType', 'size', 'customType'],
  mixins: [currency],
  data() {
    return {
      total: '',
    }
  },
  computed: {
    seperateNum() {
      return this.currency(parseInt(this.summary / 1000))
    },
  },
  watch: {
    summary: {
      handler: function (val, oldVal) {
        this.total = val
      },
      deep: true,
    },
  },
}
</script>
